import { useCallback, useEffect, useRef } from 'react';
/**
 * `useClearableTimeout` returns a function just like `setTimeout`, and also
 * returns a function to clear it (if it's still alive).
 * It manages the timeout ID internally, and clears the timeout when dismounting.
 *
 * @returns `[set, clear]` `set` can be used the same way as `setTimeout`.
 */
export function useClearableTimeout() {
    const timeoutId = useRef(undefined);
    const clear = useCallback(() => {
        if (timeoutId.current !== undefined) {
            clearTimeout(timeoutId.current);
            timeoutId.current = undefined;
        }
    }, []);
    useEffect(() => clear, [clear]);
    const set = useCallback((callback, ms) => {
        timeoutId.current = setTimeout(() => {
            callback();
            timeoutId.current = undefined;
        }, ms);
    }, []);
    return [set, clear];
}
